import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_2 = {
  key: 0,
  class: "flex items-center space-x-8 text-black-lp-300"
}
const _hoisted_3 = {
  key: 0,
  class: "w-28"
}
const _hoisted_4 = { class: "flex-grow text-16px" }
const _hoisted_5 = { class: "text-12px xxl:text-14px" }
const _hoisted_6 = { class: "font-semibold" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" a.n ")
const _hoisted_8 = { class: "font-semibold uppercase" }
const _hoisted_9 = { style: {"width":"86px"} }
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { class: "text-black-lp-300 text-12px xxl:text-14px" }, " Belum ada rekening bank yang tersimpan. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_BankModal = _resolveComponent("BankModal")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_Title, {
      label: "Informasi Bank",
      hint: "(Opsional)"
    }),
    (!!_ctx.bankDetail.accountName && !_ctx.isAddBank)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (!!_ctx.bankDetail.bankName.value && false)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("img", {
                  src: 
          require(`@/app/ui/assets/images/${_ctx.bankDetail.bankName.value}.png`)
        ,
                  class: "w-28",
                  alt: ""
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_4, [
            _createVNode("p", _hoisted_5, _toDisplayString(_ctx.bankDetail.bankLabel), 1),
            _createVNode("p", _hoisted_6, _toDisplayString(_ctx.bankDetail.accountNo), 1),
            _createVNode("p", null, [
              _hoisted_7,
              _createVNode("span", _hoisted_8, _toDisplayString(_ctx.bankDetail.accountName), 1)
            ]),
            _createVNode("p", null, _toDisplayString(_ctx.bankDetail.email), 1)
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_button_fill, {
              onClick: _cache[1] || (_cache[1] = () => _ctx.onConfirmDelete(true)),
              title: "Hapus",
              "font-bold": "",
              class: "text-red-lp-300 px-8",
              style: {"background-color":"white"}
            })
          ])
        ]))
      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          _hoisted_10,
          _createVNode(_component_LpButton, {
            onClick: _ctx.onAddBank,
            "text-color": "red-lp-100",
            outline: "",
            title: "Tambah Rekening Bank",
            "font-bold": ""
          }, null, 8, ["onClick"])
        ], 64)),
    (_ctx.isAddBank)
      ? (_openBlock(), _createBlock(_component_BankModal, {
          key: 2,
          type: "bank"
        }))
      : _createCommentVNode("", true),
    (_ctx.isDelete)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 3,
          onSubmit: _ctx.onDeleteBank,
          onClose: () => _ctx.onConfirmDelete(false),
          title: "Konfirmasi Penghapusan",
          message: "\n      Pastikan kembali, data rekening bank yang sudah dihapus tidak dapat dikembalikan.\n    ",
          image: "are-you-sure",
          textSuccess: "Hapus",
          textCancel: "Kembali",
          class: "px-8"
        }, null, 8, ["onSubmit", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}